// extracted by mini-css-extract-plugin
module.exports = {"mainSectionWrapper":"MainSection_mainSectionWrapper__2V1DV","bigHeroImg":"MainSection_bigHeroImg__2X5cx","resultsWrapper":"MainSection_resultsWrapper__-N1TA"};